'use client';
import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { getDashboardPathForRoles, getSession } from '@/lib/auth/session';

/**
 * The site root is not a real page - it only decides where to send the visitor:
 * their own role's landing page if logged in, otherwise the login screen. It used
 * to statically render the mock, unwired Organizer Dashboard here, which meant any
 * authenticated visitor (of any role) landed on that mock content at "/".
 */
export default function HomePage() {
  const router = useRouter();

  useEffect(() => {
    const session = getSession();
    router.replace(session ? getDashboardPathForRoles(session.roles) : '/sign-up-login-screen');
  }, [router]);

  return null;
}
